export const COUNTUP_OPTIONS = {
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimal: '.',
  prefix: '$'
};

export const COUNTUP_OPTIONS_NO_PREF = {
  useEasing: true,
    useGrouping: true,
    separator: ',',
    decimal: '.',
}



// WEBPACK FOOTER //
// ./src/constants/countUp.js